import { useConfig } from "@/contexts/cdpConfig";
export const useGetThumbnailGalleryVariant = () => {
    var _a;
    const featureFlags = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.featuresFlags;
    const variationFlag = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags["seeker_cdp_thumbnails_gallery"];
    if (variationFlag === "b") {
        return true;
    }
    return false;
};
